import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { PersonClient } from '@models/clients';
import { IdentificationPriority } from '@models/identification';
import { IDVStatus } from '@models/idv';
import { IdvService } from '@services/idv/idv.service';
import {
	IDSyncData,
	IdvReviewModalComponent,
	IdvReviewModalData,
} from '../../idv-review-modal.component';
import { concatMap } from 'rxjs/operators';

@Component({
	selector: 'app-confirm-details',
	templateUrl: './confirm-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ConfirmDetailsComponent {
	public ICON = ICON;
	public isSending = false;
	public payload: IDSyncData[] = [];
	public hasFirstId = false;
	public hasSecondId = false;
	public client: PersonClient;
	@Input() public stepCount: number;
	@Input() public set syncArray(payload: IDSyncData[]) {
		this.payload = payload;
		this.hasFirstId = payload.some(
			(x) => x.overwriteSlot === IdentificationPriority.PRIMARY,
		);
		this.hasSecondId = payload.some(
			(x) => x.overwriteSlot === IdentificationPriority.SECONDARY,
		);
	}
	@Input() set data(value: IdvReviewModalData) {
		this.client = value.client;
	}
	@Output() public stepCountChange = new EventEmitter<number>();
	@Output() public syncArrayChange = new EventEmitter<IDSyncData[]>();

	constructor(
		private dialogRef: MatDialogRef<IdvReviewModalComponent>,
		private idvService: IdvService,
	) {}

	back() {
		this.stepCountChange.emit(this.stepCount - 1);
		this.syncArrayChange.emit(this.payload.slice(0, -1));
	}

	confirm() {
		this.isSending = true;

		if (this.payload.length) {
			this.idvService
				.setIdDetails(this.payload)
				.pipe(
					concatMap(() =>
						this.idvService.setIdvStatus(this.client?.idv, IDVStatus.VERIFIED),
					),
				)
				.subscribe(
					() => {
						this.isSending = false;
						this.dialogRef.close();
					},
					(error) => {
						this.isSending = false;
						console.error(error);
					},
				);
		} else {
			this.dialogRef.close();
		}
	}
}
